import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

/**
 * Styled container component for pause icon in pause ad modal.
 * Positions the pause icon at the top-left of the pause ad display.
 */
const PauseAdPauseIconContainer = styled.div`
  position: fixed;
  top: ${Screen.widthRatio * 100}px;
  left: ${Screen.widthRatio * 85}px;
`;

export default PauseAdPauseIconContainer;
